import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n/config"; // UI 다국어(i18next) 전역 인스턴스 초기화 + <html lang/dir> 동기화
import Router from "./helpers/Router";
import { applyDevFavicon } from "./helpers/brand";
import { initPosthog } from "./utils/posthog.ts";
import { watchStaticHead } from "./helpers/staticHead";

window.__authCallbackFragment = window.location.hash;
window.__authCallbackSearch = window.location.search;

initPosthog();
applyDevFavicon();
watchStaticHead();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>
);
